import { hasAnyAuthToken } from '@repo/api';
import { useUserDetailsQuery } from '@repo/lib';
import { UserPermissionMap } from '@repo/types';

export type PermissionKey = keyof UserPermissionMap;

interface PermissionRequirements {
  allOf?: PermissionKey[];
  anyOf?: PermissionKey[];
}

export const hasRequiredPermissions = (
  permissions: UserPermissionMap | undefined,
  requirements: PermissionRequirements,
) => {
  const { allOf = [], anyOf = [] } = requirements;

  const hasAllPermissions = allOf.every((permissionKey) =>
    Boolean(permissions?.[permissionKey]),
  );
  const hasAnyPermissions =
    anyOf.length === 0 ||
    anyOf.some((permissionKey) => Boolean(permissions?.[permissionKey]));

  return hasAllPermissions && hasAnyPermissions;
};

export const useCurrentPermissions = () => {
  const hasAuthToken = hasAnyAuthToken();
  const { isPending, user } = useUserDetailsQuery(hasAuthToken);

  return {
    isPending,
    permissions: user?.permissions,
  };
};
